import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';
import {
  DataModuleVORaw,
  DataWorkshopEntityRaw,
} from '@edgvr-front/data/domain';
import {
  DataWorkshopWorkshopsListPageActions,
  DataWorkshopModulesListPageActions,
} from '../actions';

export const DATA_WORKSHOPS_FEATURE_KEY = 'data-workshops';

export interface DataWorkshopsState extends EntityState<DataWorkshopEntityRaw> {
  count: number;
  page: number;
  loading: boolean;
  loaded: boolean;
  selectedDataWorkshop: null | DataWorkshopEntityRaw;
  selectedDataModule: null | DataModuleVORaw;
}

export const dataWorkshopsAdapter: EntityAdapter<DataWorkshopEntityRaw> =
  createEntityAdapter<DataWorkshopEntityRaw>({
    sortComparer: (lhs: DataWorkshopEntityRaw, rhs: DataWorkshopEntityRaw) =>
      lhs.id - rhs.id,
    selectId: (_) => _.id,
  });

const initialState: DataWorkshopsState = dataWorkshopsAdapter.getInitialState({
  count: 0,
  page: 0,
  loading: false,
  loaded: false,
  selectedDataWorkshop: null,
  selectedDataModule: null,
});

const reducer = createReducer(
  initialState,
  on(
    DataWorkshopWorkshopsListPageActions.dataWorkshopsList,
    (state, { page }) => ({ ...state, loading: true })
  ),
  on(
    DataWorkshopWorkshopsListPageActions.dataWorkshopsListSuccess,
    (state, { dataWorkshops, count, page }) =>
      dataWorkshopsAdapter.setMany(
        dataWorkshops.map((_) => _.toJSON()),
        {
          ...dataWorkshopsAdapter.removeAll(state),
          count,
          page,
          loading: false,
          loaded: true,
        }
      )
  ),
  on(
    DataWorkshopWorkshopsListPageActions.dataWorkshopsListFailure,
    (state) => ({ ...state, loading: false })
  ),
  on(
    DataWorkshopModulesListPageActions.selectedDataWorkshopSet,
    (state, { dataWorkshop }) => ({
      ...state,
      selectedDataWorkshop: dataWorkshop.toJSON(),
    })
  ),
  on(
    DataWorkshopModulesListPageActions.selectedDataModuleSet,
    (state, { dataModule }) => ({
      ...state,
      selectedDataModule: dataModule.toJSON(),
    })
  ),
  on(
    DataWorkshopModulesListPageActions.dataWorkshopGetSuccess,
    (state, { dataWorkshop }) => ({
      ...state,
      selectedDataWorkshop: dataWorkshop.toJSON(),
    })
  )
);

export function dataWorkshopsReducer(
  state: DataWorkshopsState | undefined,
  action: Action
) {
  return reducer(state, action);
}
